export enum ValidationTypes {
  TOTAL_NUM_OF_BOXES_FBA = "TOTAL_NUM_OF_BOXES_FBA",
  INTERNATIONAL_ORDER = "INTERNATIONAL_ORDER",
  FBA_INVALID_DIMS = "FBA_INVALID_DIMS",
  EACHES_PICKING = "EACHES_PICKING",
}
